"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var detect_node_1 = __importDefault(require("detect-node"));
var util_1 = __importDefault(require("util"));
var shared_1 = require("mad-logs/lib/shared");
// Set global inspect options (if currently in Node)
if (detect_node_1.default) {
    util_1.default.inspect.defaultOptions.colors = true;
    util_1.default.inspect.defaultOptions.depth = 2;
    util_1.default.inspect.defaultOptions.breakLength = 100;
    util_1.default.inspect.defaultOptions.showHidden = false;
    util_1.default.inspect.defaultOptions.maxArrayLength = 3;
}
// Both sets up a logger & globally binds the util.inspect method to mad-logs' Log class,
// setting it to be used for all future object logging done by the mad-logs shared sub-module.
var log = shared_1.logFactory('log-config.ts', shared_1.Styles.lucky, util_1.default.inspect);
log.silly('INITIAL LOG. isNode?', detect_node_1.default);
// Increase stacktrace limit
Error.stackTraceLimit = Infinity;
//# sourceMappingURL=log-config.js.map